import service from "@/api/request";
/**
 * @description 获取专栏学习趋势数据
 * @returns 返回数据
 */
export const getColumnStudayData = (data) => service.getByParams(`/courseAdmin/courseStudyDailyStatistics/courseStudyTrendData`, data);
export const getColumnStudayList = (data) => service.getByParams(`/courseAdmin/userProgress/courseUserProgressStatisticPage`, data);
export const getColumnStudayCount = (id) => service.getByQuery(`/courseAdmin/course/courseStatistic?courseId=${id}`);
export const getColumnTaskList = (data) => service.getByParams(`/courseAdmin/userProgress/courseTaskProgressStatisticsPage`, data);
